import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@app/store/types';

interface EmbeddedDraftPreviewState {
  pdfArrayBuffer: ArrayBuffer | null;
}

const initialState: EmbeddedDraftPreviewState = {
  pdfArrayBuffer: null,
};

const embeddedDraftPreviewSlice = createSlice({
  name: 'embeddedDraftPreview',
  initialState,
  reducers: {
    resetEmbeddedDraftPreview() {
      return initialState;
    },
    loadEmbeddedDraftPreview(
      state,
      action: PayloadAction<{
        pdfArrayBuffer: ArrayBuffer;
      }>
    ) {
      state.pdfArrayBuffer = action.payload.pdfArrayBuffer;
    },
  },
});

const getEmbeddedDraftPreviewState = (state: RootState) => state.embeddedDraftPreview;

export const getPdfArrayBuffer = (state: RootState) =>
  getEmbeddedDraftPreviewState(state).pdfArrayBuffer;

export const { resetEmbeddedDraftPreview, loadEmbeddedDraftPreview } =
  embeddedDraftPreviewSlice.actions;

export const { reducer } = embeddedDraftPreviewSlice;
